import { createStore } from 'vuex'
import axios from 'axios'

import router from './router'
import config from './config'

import { eventBus } from './main'

export default createStore({

  state: {
    token: null,
    username: null,
    revealed: 0
  },

  mutations: {
    authUser (state, userData) {
      state.token = userData.token;
      state.username = userData.username;
    },

    clearAuthData (state) {
      state.token = null;
      state.username = null;
      state.revealed = 0;

      localStorage.removeItem('token');
      localStorage.removeItem('username');
      localStorage.removeItem('expirationDate');
    },

    increaseReveal (state) {
      state.revealed++;
    }
  },

  actions: {
    setLogoutTimer ({commit}, expirationTime) {
      setTimeout(() => {commit('clearAuthData')}, expirationTime * 1000)
    },
    login ({commit, dispatch}, authData) {
      axios.post(config.apiServerAdress + '/authenticate', {
        username: authData.username,
        password: authData.password
      })
        .then(res => {
          const now = new Date();
          const expirationDate = new Date(now.getTime() + res.data.expiresIn * 1000);

          localStorage.setItem('token', res.data.token);
          localStorage.setItem('username', res.data.username);
          localStorage.setItem('expirationDate', expirationDate);

          commit('authUser', {
            token: res.data.token,
            username: res.data.username
          });
          dispatch('setLogoutTimer', res.data.expiresIn);
          router.replace('/');
        })
        .catch(error => {
          console.log(error);
          eventBus.emit('loginError', error);
        })
    },
    tryAutoLogin ({commit}) {
      const token = localStorage.getItem('token');
      if (!token) {
        return
      }
      const expirationDate = new Date(localStorage.getItem('expirationDate'));
      const now = new Date();
      if (now >= expirationDate) {
        commit('clearAuthData');
        return
      }
      const username = localStorage.getItem('username');
      commit('authUser', {
        token: token,
        username: username
      })
    },
    logout ({commit}) {
      commit('clearAuthData');
      localStorage.removeItem('expirationDate');
      localStorage.removeItem('token');
      localStorage.removeItem('username');
      router.replace('/signin');
    },

    incReveal({commit}) {
      commit('increaseReveal');
    }
  },
  getters: {
    username (state) {
      return state.username
    },
    isAuthenticated (state) {
      return state.token !== null
    },
    reveal (state) {
      return state.revealed
    }
  }
})
